import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { routes } from "constants/routes";
const PrivateRoutes = () => {
  const authContext = useAuth();
  return !!authContext?.user ? <Outlet /> : <Navigate to={routes.login} />;
};

export default PrivateRoutes;
